import { Button, CircularProgress, Tooltip } from "@mui/material";
import { SaveAlt as SaveAltIcon } from "@mui/icons-material";

export const APPLY_RESTRICTED_MESSAGE = "Applying an auto-close requires the Admin or Auto-Approve Preview role";

interface AutoCloseApplyButtonProps {
  /** Admin or AccessAutoApprovePreview — anyone else sees the button disabled, with the reason on hover. */
  canApply: boolean;
  applying: boolean;
  disabled: boolean;
  onClick: () => void;
}

// The Auto-Approve Preview's "Apply & save". The preview stays open to everyone who can see the tab; only
// committing it is restricted.
const AutoCloseApplyButton = ({ canApply, applying, disabled, onClick }: AutoCloseApplyButtonProps) => {
  const button = (
    <Button
      variant="contained"
      disableElevation
      color="primary"
      startIcon={applying ? <CircularProgress size={15} color="inherit" /> : <SaveAltIcon />}
      onClick={onClick}
      disabled={!canApply || disabled}
      sx={{ fontWeight: 700 }}
    >
      Apply &amp; save
    </Button>
  );
  if (canApply) return button;
  // A disabled button fires no pointer events, so the tooltip hangs off a wrapper.
  return (
    <Tooltip title={APPLY_RESTRICTED_MESSAGE}>
      <span>{button}</span>
    </Tooltip>
  );
};

export default AutoCloseApplyButton;
